import React from 'react';

import Helmet from './Helmet';

const Title = 'OpenID Connect (OIDC) SSO Integration | Canny';
const Description = 'Let your employees log in to your Canny account with any OIDC provider.';
const Image = 'https://canny.io/images/canny-social.png';

const OpenIDConnectSSOLandingHelmet = () => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: 'https://canny.io/integrations/openid' },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}
    />
  );
};
export default OpenIDConnectSSOLandingHelmet;
